// extracted by mini-css-extract-plugin
export var readonly = "_dq-1";
export var star = "_dq-0";